// Content for a Leaflet popup whose words are not ours.
//
// `bindPopup(string)` and `setPopupContent(string)` are
// `innerHTML`: Leaflet parses whatever string it is
// handed. The names our maps print come from people: a
// venue name a MERCHANT typed, printed on every
// CUSTOMER's checkout, and a customer's own address
// label. Interpolated into a string, a venue named
// `<img src=x onerror=...>` ran script in the browser of
// everyone who ordered from it (CAL-522).
//
// So the popup is built as nodes and every word goes in
// through `textContent`, which never parses. Handed an
// ELEMENT, Leaflet appends it instead of parsing it.
//
// An element and never a DocumentFragment: Leaflet
// re-appends the same content on every open, and a
// fragment empties itself into the page the first time,
// so the second open would draw an empty popup.
//
// @param {string} heading - bold first line (the
//   translated "Delivering from"); omit for none.
// @param {string} text - the name itself.
// @returns {HTMLElement}
export function textPopup({ heading = "", text = "" }) {
  const content = document.createElement("div");

  if (heading) {
    const strong = document.createElement("strong");
    strong.textContent = heading;
    content.append(strong, document.createElement("br"));
  }

  content.append(document.createTextNode(text));

  return content;
}
